var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTakeOutAccepted = function SvgTakeOutAccepted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 31C23.2843 31 30 24.2843 30 16C30 7.71573 23.2843 1 15 1C6.71573 1 0 7.71573 0 16C0 24.2843 6.71573 31 15 31ZM22.9007 12.1211C23.5199 11.44 23.4697 10.3859 22.7886 9.76677C22.1075 9.14759 21.0534 9.19778 20.4342 9.87888L13.1748 17.8643L9.40112 14.7196C8.69399 14.1304 7.64305 14.2259 7.05378 14.933C6.46451 15.6402 6.56004 16.6911 7.26717 17.2804L12.2672 21.447C12.9529 22.0184 13.967 21.9482 14.5674 21.2878L22.9007 12.1211Z",
    fill: "currentColor"
  })));
};
export default SvgTakeOutAccepted;